import {atom} from 'recoil';

export const news = atom({
  key: 'news',
  default: null,
});

export const singleNews = atom({
  key: 'singleNews',
  default: null,
});
